import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, subtitle, icon, iconBg, trend }) => {
  return (
    <div className="bg-card rounded-lg p-4 md:p-5 shadow-elevation-1 border border-border transition-smooth hover:shadow-elevation-2">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1 min-w-0">
          <p className="text-xs md:text-sm text-muted-foreground mb-1">{title}</p>
          <h4 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground data-text">
            {value}
          </h4>
        </div>
        <div className={`w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${iconBg}`}>
          <Icon name={icon} size={18} color="white" />
        </div>
      </div>
      <div className="flex items-center justify-between">
        <p className="text-xs md:text-sm text-muted-foreground line-clamp-1">{subtitle}</p>
        {trend && (
          <div className={`flex items-center gap-1 ${trend?.direction === 'up' ? 'text-success' : 'text-error'}`}>
            <Icon name={trend?.direction === 'up' ? 'ArrowUp' : 'ArrowDown'} size={14} />
            <span className="text-xs data-text whitespace-nowrap">{trend?.value}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricCard;